import { benefitStatuses } from 'store/benefits';
import { employeeStatuses } from 'store/employees';
import { sortFiltersSchema } from 'utils/schemas';
import { z } from 'zod';

export const employeeGroupsFiltersSchema = z
  .object({
    name: z.string().catch(''),
    employeeGroups: z.array(z.string()).catch([]),
    benefits: z.array(z.string()).catch([]),
    companies: z.array(z.string()).catch([]),
    departments: z.array(z.string()).catch([]),
    teams: z.array(z.string()).catch([]),
    orgStructure: z.array(z.string()).catch([]),
    employeeStatus: z.array(z.enum(employeeStatuses)).catch([]),
    benefitStatus: z.array(z.enum(benefitStatuses)).catch([]),
  })
  .merge(sortFiltersSchema);
